import { LIMIT } from '@/constants';
import { fetchGiftDetails, fetchGiftList } from '@/services/apis';
import { GiftState, LoadMoreStatus, type AnyObj } from '@/types';
import { commonUtils } from '@/utils';
import { defineStore } from 'pinia';

interface State {
  /** 礼品列表 */
  giftList: any[];
  /** 礼品详情 */
  giftDetails: any;
  /** 礼品列表请求选项 */
  options: { filterState: AnyObj; skip: number };
  /** 列表加载状态 */
  loadStatus: LoadMoreStatus;
  /** 标签栏下标 */
  tabIndex: number;
  /** 礼品ID */
  compRecordId: string;
  /** 是否自动弹窗 */
  autoOpen: boolean;
}

export const useGiftStore = defineStore('gift', {
  state: (): State => ({
    giftList: [],
    giftDetails: null,
    options: {
      filterState: {
        in: [GiftState.created, GiftState.draw],
      },
      skip: 0,
    },
    tabIndex: 0,
    loadStatus: LoadMoreStatus.more,
    compRecordId: '',
    autoOpen: false,
  }),

  getters: {},

  actions: {
    /**
     * 获取礼品列表
     * @param skip - 数据略过个数
     */
    async fetchGiftList(skip: number, refresh?: boolean) {
      try {
        const res = await fetchGiftList(skip, this.options.filterState);
        if (res.data) {
          const list = res.data.value.compRecords.items;

          if (list.length < LIMIT) {
            this.loadStatus = LoadMoreStatus.noMore;
          } else {
            this.loadStatus = LoadMoreStatus.more;
          }

          if (refresh) {
            this.giftList = res;
          } else {
            this.giftList = [...this.giftList, ...res];
          }

          return this.giftList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 获取礼品详情
     * @param id - 礼品id
     */
    async fetchGiftDetails(id: string) {
      try {
        const res = await fetchGiftDetails(id);
        if (res.data) {
          this.giftDetails = res.data.value?.compRecord;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getGiftList(skip: number = 0) {
      await this.fetchGiftList(skip);
      return this.giftList;
    },
    async getGiftDetails(id: string) {
      if (commonUtils.func.isEmpty(this.giftDetails)) await this.fetchGiftDetails(id);
      return this.giftDetails;
    },
  },
});
